<span [class]="getClass()" *ngIf="value">{{getValue()}}</span>